
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"bundleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Bundle"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableNow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gtnPermissionId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"identifierTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":170}};
    doc.loc.source = {"body":"fragment bundleFragment on Bundle {\n  id\n  nameText\n  priceInCents\n  availableNow\n  enabled\n  guestPermissions {\n    gtnPermissionId\n  }\n  identifierTypes {\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
